var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:[
    _vm.$route.name === 'HistoryEvent' ? _vm.$style.eventContainer : _vm.$style.root
  ],style:({
    overflow: 'auto',
    maxHeight: _vm.$route.name === 'HistoryEvent' ? '100%' : `${_vm.tableHeight}px`
  }),attrs:{"fluid":"","fill-height":"","pa-0":""}},[(_vm.$route.name === 'HistoryEvent')?_c('DuaMessageRevisionSelect'):_vm._e(),_c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('DuaMessageForm',{key:_vm.created})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }